<template>
  <div class="pos-layout">
    <PosHeader />


    <!-- CONTENIDO PRINCIPAL -->
    <v-main class="pos-main">
      <!-- Retiro obligatorio (alerta de caja): el diálogo ya es una card -->
      <v-dialog v-model="dialogVisible" persistent max-width="560">
        <RetiroEfectivoCaja v-if="alerta" />
      </v-dialog>

      <!-- CONTENEDOR SCROLLABLE -->
      <div class="pos-router">
        <router-view :menuItems="menuItems" />
      </div>
    </v-main>
  </div>
</template>


<script>
import PosHeader from "@/views/pos/PosHeader.vue";
import RetiroEfectivoCaja from "@/views/pos/caja/CajaRetiroEfectivo.vue";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "PosLayout",
  components: {
    PosHeader,
    RetiroEfectivoCaja,
  },
  data: () => ({
    bloqueada: true,

    links: [],
    drawer: true,
    miniDrawer: true,
    mini: true,
    novedadesDrawer: true,
    currentBranch: "Sucursal Central",
    currentTime: new Date().toLocaleTimeString(),
    menuName: "administrador",

  }),
  computed: {
    ...mapState("sucursales", ["sucursal", "caja", "arqueoCaja"]),
    ...mapState("sucursales", ["configuracion"]),
    ...mapGetters(["getLinksDelMenu"]),
    ...mapGetters("auth", ["tienePermiso", "userEsEmpleado"]),

    puedeGestionarProductosEmpresa() {
      return this.tienePermiso("crear_producto");
    },

    puedeRealizarInventario() {
      return this.tienePermiso("realizar_inventario");
    },

    menuItems() {
      if (!this.arqueoCaja) {
        const items = [
          { color: "warning", icon: "mdi-cash-register", name: "Iniciar caja", route_name: "pos.cajas" },
        ];
        if (this.puedeRealizarInventario) {
          items.push({ color: null, icon: "mdi-clipboard-list-outline", name: "Inventarios", route_name: "pos.inventarios" });
        }
        if (this.puedeGestionarProductosEmpresa) {
          items.push({ color: null, icon: "mdi-store-outline", name: "Productos de la empresa", route_name: "empresa.productosLayout" });
        }
        return items;
      }
      const items = [
        { color: null, icon: "mdi-cash-register", name: "Nueva venta", route_name: "pos.venta.registrar" },
        { color: null, icon: "mdi-cart-outline", name: "Ventas", route_name: "pos.venta" },
        { color: null, icon: "mdi-cart-arrow-down", name: "Compras", route_name: "pos.compras" },
        { color: null, icon: "mdi-file-document-edit-outline", name: "Gastos", route_name: "pos.egresos.gastos" },
        { color: null, icon: "mdi-package-variant-closed", name: "Productos", route_name: "pos.productos.home" },
        { color: null, icon: "mdi-account-group-outline", name: "Clientes", route_name: "pos.clientes" },
        { color: null, icon: "mdi-truck-delivery-outline", name: "Proveedores", route_name: "pos.proveedores" },
        { color: null, icon: "mdi-cash-multiple", name: "Movimientos de caja", route_name: "pos.movimientos" },
      ];
      if (this.puedeRealizarInventario) {
        items.push({ color: null, icon: "mdi-clipboard-list-outline", name: "Inventarios", route_name: "pos.inventarios" });
      }
      if (this.puedeGestionarProductosEmpresa) {
        items.push({ color: null, icon: "mdi-store-outline", name: "Productos de la empresa", route_name: "empresa.productosLayout" });
      }
      return items;
    },

    menuItemsBottom() {
      if (!this.arqueoCaja) {
        const items = [
          { color: "warning", icon: "mdi-cash-register", name: "Iniciar caja", route_name: "pos.cajas" },
        ];
        if (this.puedeGestionarProductosEmpresa) {
          items.push({ color: null, icon: "mdi-store-outline", name: "Empresa", route_name: "empresa.productosLayout" });
        }
        return items;
      }
      return [
        { color: null, icon: "mdi-home-outline", name: "Inicio", route_name: "pos.dashboard" },
        { color: null, icon: "mdi-cart-outline", name: "Ventas", route_name: "pos.venta" },
        { color: null, icon: "mdi-cart-arrow-down", name: "Compras", route_name: "pos.compras" },
        { color: null, icon: "mdi-package-variant-closed", name: "Productos", route_name: "pos.productos.home" },
        { color: null, icon: "mdi-cash-multiple", name: "Movimientos", route_name: "pos.movimientos" },
      ];
    },

    dialogVisible() {
      return this.bloqueo && this.alerta;
    },
    bloqueo() {
      return this.$store.getters["notificaciones/bloqueoRetiroDinero"];
    },
    alerta() {
      return this.$store.state.notificaciones.alerta_retiro;
    },
    titleNavigation() {
      return this.sucursal ? this.sucursal.nombre : "Sin sucursal";
    },
    subtitleNavigation() {
      return this.caja ? this.caja.nombre : "Sin caja";
    },
    total() {
      return this.cart.reduce((sum, p) => sum + p.qty * p.price, 0);
    },
    navHome() {
      if ("navHome" in this.$route.meta) {
        return this.$route.meta.navHome;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions(["fetchLinksPorMenu"]),
    ...mapActions("notificaciones", [
      "fetch_notificaciones",
      "fetch_tipo_notificaciones",
    ]),

    irARetiros() {
      this.$router.push({ name: "pos.movimientosRetiro" });
    },
    async obtenerLinksDelMenu(menuName) {
      if (menuName) {
        console.log("layoubasic", menuName);
        await this.fetchLinksPorMenu(menuName); // Espera a que la acción termine antes de continuar
        this.links = this.getLinksDelMenu(menuName);
      }
    },
    goTo(route) {
      this.$router.push(route);
    },
    newSale() {
      console.log("Nueva venta");
    },
    closeSale() {
      console.log("Cerrar venta");
    },
    handleKeyDown(e) {
      console.log("handleKeyDown PosDashboard", e.key);

      // Atajo F1: Nueva Venta
      if (e.key === "F1") {
        e.preventDefault();
        this.$router.push({ name: "pos.venta.registrar" }).catch(() => {});
      }

      // Atajo F2: Pedidos (Solo si está habilitado)
      if (e.key === "F2" && this.configuracion?.ventaConPedido) {
        console.log("Tecla F2 y configuracion apretada");

        e.preventDefault();
        this.$router.push({ name: "pos.venta.pedidos.nuevo" }).catch(() => {});
      }
    },
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },

  created() {
    window.addEventListener("keydown", this.handleKeyDown);

    this.fetch_notificaciones(1);
    this.fetch_tipo_notificaciones();
    setInterval(() => {
      this.currentTime = this.moment().format("LTS");
    }, 1000);
  },
};
</script>

<style scoped>
/* 1. El layout raíz se queda igual, controla el viewport */
.pos-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; 
}

/* 2. El main ocupa el espacio restante */
.pos-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* 3. El wrap de Vuetify debe permitir el flujo vertical */
.pos-main >>> .v-main__wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  /* CAMBIO: overflow: hidden -> auto */
  overflow: hidden; 
}

/* 4. LA CLAVE: El router es el que debe scrollear */
.pos-router {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  /* CAMBIO: Usamos 'auto' para que si el contenido es grande, aparezca el scroll */
  overflow-y: auto; 
  /* Opcional: Esto ayuda a que el scroll sea fluido en navegadores móviles */
  -webkit-overflow-scrolling: touch; 
}
</style>